import { Popover } from '@material-ui/core'
import { IPopupProps } from '@root-gipro/shared/Windows/DropDown/drop-down.props'
import '@root-gipro/shared/Windows/DropDown/DropDown.scss'
import React from 'react'

export const DropDown: React.FC<IPopupProps> = ({
	anchorEl,
	setAnchorEl,
	classes,
	style,
	transformOrigin,
	anchorOrigin,
	anchorReference,
	anchorPosition,
	children,
	container,
}) => {
	const handleClose = () => {
		setAnchorEl(null!)
	}

	return (
		<Popover
			className={classes}
			anchorOrigin={anchorOrigin}
			transformOrigin={transformOrigin}
			anchorReference={anchorReference}
			anchorPosition={anchorPosition}
			anchorEl={anchorEl}
			keepMounted
			open={!!anchorEl}
			onClose={handleClose}
			container={container}
			PaperProps={{
				style: style,
			}}
		>
			<div className='drop-down'>
				<div className='drop-down__container'> {children}</div>
			</div>
		</Popover>
	)
}
